import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Navigate, Route, Routes } from "react-router";
import { AuthProvider, RequireAuth } from "./context/authContext";
import { BikeProvider } from "./context/bikeContext";
import { EditModeProvider } from "./context/editModeContext";
import AuthLayout from "./layouts/AuthLayout";
import BikePage from "./pages/Garage/BikePage";
import Fork from "./pages/Garage/Fork";
import GaragePage from "./pages/Garage/GaragePage";
import NewBikePage from "./pages/Garage/NewBikePage";
import RequireBike from "./pages/Garage/RequireBike";
import Shock from "./pages/Garage/Shock";
import GeometryAndAdjustmentsFaq from "./pages/HowTo/GeometryAndAdjustmentsFaq";
import HowToPage from "./pages/HowTo/HowToPage";
import SuspensionFaq from "./pages/HowTo/SuspensionFaq";
import AuthAction from "./pages/Profile/AuthAction";
import Login from "./pages/Profile/Login";
import ProfilePage from "./pages/Profile/ProfilePage";
import Reset from "./pages/Profile/Reset";
import ResetSent from "./pages/Profile/ResetSent";
import Signup from "./pages/Profile/Signup";
import CloneSetupPage from "./pages/Setups/CloneSetupPage";
import History from "./pages/Setups/History";
import NewSetupPage from "./pages/Setups/NewSetupPage";
import Settings from "./pages/Setups/Settings";
import SetupPage from "./pages/Setups/SetupPage";
import SetupsPage from "./pages/Setups/SetupsPage";

const App = () => {
  const queryClient = new QueryClient();

  return (
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <BikeProvider>
            <EditModeProvider>
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/reset" element={<Reset />} />
                <Route path="/reset/sent" element={<ResetSent />} />
                <Route path="/auth/action" element={<AuthAction />} />
                <Route path="/signup" element={<Signup />} />
                <Route element={<RequireAuth />}>
                  <Route element={<RequireBike />}>
                    <Route element={<AuthLayout />}>
                      {/* Rename to bottom nav layout? */}
                      <Route
                        path="/"
                        element={<Navigate to="setups" replace />}
                      />
                      <Route path="/setups">
                        <Route index element={<SetupsPage />} />
                        <Route path=":setupId" element={<SetupPage />}>
                          <Route path="settings" element={<Settings />} />
                          <Route path="history" element={<History />} />
                          <Route
                            index
                            element={<Navigate to="settings" replace />}
                          />
                        </Route>
                        <Route path="clone" element={<CloneSetupPage />} />
                      </Route>
                      <Route path="/garage">
                        <Route index element={<GaragePage />} />
                        <Route path=":bikeId" element={<BikePage />}>
                          <Route path="fork" element={<Fork />} />
                          <Route path="shock" element={<Shock />} />
                          <Route
                            index
                            element={<Navigate to="fork" replace />}
                          />
                        </Route>
                      </Route>
                      <Route path="/how-to" element={<HowToPage />}>
                        <Route path="suspension" element={<SuspensionFaq />} />
                        <Route
                          path="geometry-and-adjustments"
                          element={<GeometryAndAdjustmentsFaq />}
                        />
                        <Route
                          index
                          element={<Navigate to="suspension" replace />}
                        />
                      </Route>
                      <Route path="/profile" element={<ProfilePage />} />
                    </Route>
                    <Route path="/setups/new" element={<NewSetupPage />} />
                  </Route>
                  <Route path="/bikes/new" element={<NewBikePage />} />
                </Route>
              </Routes>
            </EditModeProvider>
          </BikeProvider>
        </AuthProvider>
      </QueryClientProvider>
    </BrowserRouter>
  );
};

export default App;
